<!-- eslint-disable -->
<template>
  <div class="maintain-brand-container">
    <div class="page-header">
      <sb-headline title="品牌管理"></sb-headline>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchData" class="search-form">
        <el-form-item label="品牌名称">
          <el-input v-model="searchData.brandName" placeholder="请输入品牌名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌类型">
          <el-select v-model="searchData.brandType" clearable placeholder="请选择品牌类型">
            <el-option label="车型品牌" :value="1"></el-option>
            <el-option label="零配件品牌" :value="2"></el-option>
            <el-option label="油站品牌" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-buttons">
          <el-button @click="pageHandler($refs.list, 1, 'reset')" plain>重置</el-button>
          <el-button type="primary" @click="pageHandler($refs.list, 1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <div class="table-header">
        <h3 class="table-title">品牌列表</h3>
        <div class="table-actions">
          <el-button
            type="primary"
            class="add-brand-btn"
            @click="brandAdd"
          >
            <i class="el-icon-plus"></i>
            <span>新增品牌</span>
          </el-button>
        </div>
      </div>

      <div class="table-wrapper">
        <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading">
          <el-table-column label="品牌编号" fixed="left" prop="brandCode" min-width="140">
            <template slot-scope="scope">
              <div class="brand-code">
                <span>{{ scope.row.brandCode }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品牌名称" prop="brandName" min-width="160">
            <template slot-scope="scope">
              <div class="brand-name">
                <span class="name-text">{{ scope.row.brandName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品牌Logo" prop="brandLogo" min-width="160">
            <template slot-scope="scope">
              <div class="brand-logo">
                <el-image
                  v-if="scope.row.brandLogo"
                  :src="scope.row.brandLogo"
                  fit="contain"
                  :preview-src-list="[scope.row.brandLogo]"
                >
                  <div slot="placeholder" class="image-placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                  <div slot="error" class="image-error">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div v-else class="no-logo">
                  <i class="el-icon-picture-outline"></i>
                  <span>暂无图片</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品牌类型" prop="brandType" min-width="120">
            <template slot-scope="scope">
              <el-tag
                :type="getBrandTypeTag(scope.row.brandType)"
                effect="light"
                size="medium"
                class="brand-type-tag"
              >
                <i class="el-icon-s-flag"></i>
                {{ getBrandTypeText(scope.row.brandType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="updateUser" min-width="100">
            <template slot-scope="scope">
              <div class="operator">
                <span>{{ scope.row.updateUser }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作时间" prop="updateTime" min-width="180">
            <template slot-scope="scope">
              <div class="update-time">
                <span>{{ scope.row.updateTime }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template slot-scope="scope">
              <div class="table-actions-cell">
                <el-tooltip content="编辑品牌" placement="top" effect="light">
                  <el-button
                    type="text"
                    size="mini"
                    class="edit-btn"
                    @click="tableHandle(1, scope.row)"
                  >
                    <i class="el-icon-edit"></i>
                    编辑
                  </el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </my-table>
      </div>

      <div v-if="!listData.length && !listLoading" class="empty-data">
        <i class="el-icon-document"></i>
        <p>暂无品牌数据</p>
      </div>
    </div>

    <!-- 新增/编辑品牌弹窗 -->
    <el-dialog
      :title="brandForm.brandCode ? '编辑品牌' : '新增品牌'"
      :visible.sync="brandAddVisible"
      width="580px"
      class="brand-dialog"
      top="6vh"
    >
      <el-form
        :model="brandForm"
        ref="brandForm"
        :rules="brandAddRules"
        label-width="100px"
        class="brand-form"
      >
        <el-form-item label="品牌名称" prop="brandName">
          <el-input
            v-model="brandForm.brandName"
            placeholder="请输入品牌名称"
            maxlength="50"
            show-word-limit
            prefix-icon="el-icon-edit"
          ></el-input>
          <div class="form-item-tip">
            品牌名称应具有辨识度，建议2-50个字符
          </div>
        </el-form-item>

        <el-form-item label="品牌Logo" prop="brandLogo">
          <div class="upload-container">
            <file-upload :maxNum="1" v-model="brandForm.brandLogo" :default-file-list="brandLogoList"></file-upload>
            <div class="upload-tip">
              <i class="el-icon-info"></i>
              建议尺寸：120x120px，支持jpg、png格式
            </div>
          </div>
        </el-form-item>

        <el-form-item label="品牌类型" prop="brandType">
          <el-radio-group v-model="brandForm.brandType" class="brand-type-group">
            <el-radio :label="1" class="brand-type-radio">
              <div class="radio-content">
                <div class="radio-icon">
                  <i class="el-icon-truck"></i>
                </div>
                <div class="radio-details">
                  <div class="radio-label">车型品牌</div>
                  <div class="radio-desc">适用于汽车品牌管理</div>
                </div>
              </div>
            </el-radio>
            <el-radio :label="2" class="brand-type-radio">
              <div class="radio-content">
                <div class="radio-icon">
                  <i class="el-icon-shopping-cart-full"></i>
                </div>
                <div class="radio-details">
                  <div class="radio-label">零配件品牌</div>
                  <div class="radio-desc">适用于汽车配件品牌管理</div>
                </div>
              </div>
            </el-radio>
            <el-radio :label="3" class="brand-type-radio">
              <div class="radio-content">
                <div class="radio-icon">
                  <i class="el-icon-coffee-cup"></i>
                </div>
                <div class="radio-details">
                  <div class="radio-label">油站品牌</div>
                  <div class="radio-desc">适用于加油站品牌管理</div>
                </div>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <div class="form-footer-tip">
          <i class="el-icon-warning-outline"></i>
          <span>添加品牌后，系统将自动生成品牌编号</span>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="brandAddVisible = false" plain>取 消</el-button>
        <el-button type="primary" @click="dialogConfirm" :loading="submitLoading">
          <i class="el-icon-check"></i>
          {{ brandForm.brandCode ? '保存修改' : '确认添加' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import FileUpload from "@/components/scope/file-upload.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { FileUpload },
    data() {
    //这里存放数据
      return {
        listData: [{},{},{}],
        // 搜索数据
        searchData: {
          brandName: undefined,                  //品牌名称
          brandType: undefined,                  //品牌类型
        },
        listLoading: false,             //列表loading
        sortField: '',                  // 排序字段

        brandAddVisible: false,     //新增品牌弹窗状态

        brandForm: {             //新增品牌表单数据
          brandCode: '',                  //品牌编码
          brandName: '',                  //品牌名称
          brandLogo: "",                  //品牌Logo
          brandType: '',                  //品牌类型 1-车型品牌 2-零配件品牌 3-油站品牌
          tenantCode: '',
          orgCode: '',
        },
        brandAddRules: {            //表单验证
          brandName: [
            { required: true, message: '请输入品牌名称', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          ],
          brandLogo: [
            { required: true, message: '请上传品牌logo', trigger: 'change' }
          ],
          brandType: [
            { required: true, message: '请选择品牌类型', trigger: 'change' }
          ]
        },
        brandLogoList: [],               //品牌logoList
        submitLoading: false, // 提交loading状态
        uploadUrl: '',
        headers: {},
      };
    },
  filters: {

  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageHandler(params, num, type) {
      if(type == 'reset'){
        this.resetSearchData();
      }
      this.getBrandList(params, num ? num : params.pageNum, params.pageSize);
    },
    // 新增品牌
    brandAdd(){
      // 先重置表单和图片列表
      this.brandLogoList = [];
      this.brandForm = {                //新增品牌表单数据
        brandCode: '',                  //品牌编码
        brandName: '',                  //品牌名称
        brandLogo: "",                  //品牌Logo
        brandType: '',                  //品牌类型
      }
      this.$nextTick(() => {
        this.brandAddVisible = true;
      });
    },
    // 弹窗确认
    dialogConfirm(){
      this.$refs.brandForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$store.dispatch('management/postMaintainBrandSave',{
            ...this.brandForm
          }).then(res => {
            this.$message.success('操作成功');
            this.$refs.list.init();
            this.brandAddVisible = false;
          }).finally(() => {
            this.submitLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 表格内操作
    tableHandle(type, row) {
      switch (type) {
        case 1:     //编辑
          // 先重置表单和图片列表
          this.brandLogoList = [];
          this.brandForm = {
            brandCode: '',
            brandName: '',
            brandLogo: '',
            brandType: '',
          };
          
          // 再设置新的数据
          this.$nextTick(() => {
            Object.keys(this.brandForm).forEach(key => {
              this.brandForm[key] = row[key]
            });
            if (row.brandLogo) {
              this.brandLogoList = [{url: row.brandLogo}];
            }
            this.brandAddVisible = true;
          });
          break;

        default:
          break;
      }
    },

    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        brandName: undefined,
        brandType: undefined,
      }
    },

    // 获取品牌列表
    getBrandList(params,pageNum,pageSize) {
      this.listLoading = true;
      this.$store.dispatch('management/postMaintainBrandList',{
        ...this.searchData,
        pageNum,
        pageSize
      }).then(res => {
        if(res.code == 0){
          console.log(res)
          this.listData = res.data.list;
          params.render(res.data.total);
        }
        this.listLoading = false;
      })
    },

    // 获取品牌类型标签样式
    getBrandTypeTag(type) {
      const typeMap = {
        1: 'primary',
        2: 'success',
        3: 'warning'
      }
      return typeMap[type] || 'info'
    },

    // 获取品牌类型文本
    getBrandTypeText(type) {
      const typeMap = {
        1: '车型品牌',
        2: '零配件品牌',
        3: '油站品牌'
      }
      return typeMap[type] || '-'
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
.maintain-brand-container {
  padding: 24px;
  background-color: #f6f8fb;
  min-height: 100%;
  box-sizing: border-box;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    .add-brand-btn {
      height: 40px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 8px;
      background: linear-gradient(to right, #1890ff, #36a9f7);
      border: none;
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 6px;

      i {
        font-size: 16px;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(24, 144, 255, 0.3);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
      }
    }
  }

  .search-section {
    background: #ffffff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 10, 26, 0.05);
    margin-bottom: 24px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: linear-gradient(to bottom, #1890ff, #36a9f7);
      border-radius: 2px 0 0 2px;
    }

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 10, 26, 0.1);
      transform: translateY(-2px);
    }

    .search-form {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 16px;

      .el-form-item {
        margin-bottom: 0;
        margin-right: 0;

        ::v-deep .el-form-item__label {
          font-weight: 500;
          color: #2c3e50;
          transition: color 0.3s ease;
          padding-right: 8px;
        }

        ::v-deep .el-input__inner {
          border-radius: 8px;
          transition: all 0.3s ease;
          height: 40px;
          border-color: #e2e8f0;
          padding: 0 16px;

          &:hover {
            border-color: #1890ff;
          }

          &:focus {
            border-color: #1890ff;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.15);
          }
        }

        ::v-deep .el-select {
          width: 220px;

          .el-input__suffix {
            transition: transform 0.3s ease;
          }

          &:hover .el-input__suffix {
            transform: rotate(90deg);
          }
        }

        ::v-deep .el-input__icon {
          transition: all 0.3s ease;
        }

        ::v-deep .el-input.is-focus .el-input__suffix-inner {
          color: #1890ff;
        }
      }

      .search-buttons {
        margin-left: auto;
        display: flex;
        gap: 12px;

        .el-button {
          padding: 0 20px;
          font-weight: 500;
          border-radius: 8px;
          transition: all 0.3s ease;
          height: 40px;
          position: relative;
          overflow: hidden;

          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 0;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.2);
            transition: width 0.3s ease;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 10, 26, 0.1);

            &:before {
              width: 100%;
            }
          }

          &:active {
            transform: translateY(0);
          }

          &[plain] {
            border-color: #e2e8f0;
            color: #4a5568;

            &:hover {
              border-color: #1890ff;
              color: #1890ff;
            }
          }
        }
      }
    }
  }

  .table-section {
    background: #ffffff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 10, 26, 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 10, 26, 0.1);
    }

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px dashed #e2e8f0;

      .table-title {
        font-size: 16px;
        font-weight: 600;
        color: #1a202c;
        margin: 0;
        position: relative;
        padding-left: 16px;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 16px;
          background: linear-gradient(to bottom, #1890ff, #36a9f7);
          border-radius: 2px;
        }
      }

      .table-actions {
        display: flex;
        align-items: center;
        gap: 12px;

        .sort-btn {
          display: flex;
          align-items: center;
          color: #1890ff;
          padding: 8px;
          transition: all 0.3s ease;
          border-radius: 4px;

          i {
            margin-right: 4px;
            font-size: 14px;
          }

          &:hover {
            background-color: #e6f7ff;
          }
        }

        .add-brand-btn {
          height: 36px;
          padding: 0 16px;
          font-size: 13px;
        }
      }
    }

    .table-wrapper {
      position: relative;
      overflow: hidden;
    }

    .brand-code {
      display: flex;
      align-items: center;

      .code-icon {
        font-size: 14px;
        color: #64748b;
        margin-right: 6px;
      }
    }

    .brand-logo {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-image {
        width: 64px;
        height: 64px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;
        background: #fff;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(0, 10, 26, 0.1);
        }
      }

      .image-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f8fafc;
        color: #1890ff;
      }

      .image-error {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #f8fafc;
        color: #a0aec0;
        font-size: 20px;
      }

      .no-logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        border-radius: 8px;
        background: #f8fafc;
        border: 1px dashed #e2e8f0;

        i {
          font-size: 20px;
          color: #a0aec0;
          margin-bottom: 4px;
        }

        span {
          color: #718096;
          font-size: 12px;
        }
      }
    }

    .operator {
      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        color: #64748b;
        margin-right: 6px;
      }
    }

    .update-time {
      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        color: #64748b;
        margin-right: 6px;
      }
    }

    .table-actions-cell {
      display: flex;
      justify-content: center;
    }

    .empty-data {
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #a0aec0;

      i {
        font-size: 48px;
        margin-bottom: 16px;
      }

      p {
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .brand-dialog {
    ::v-deep .el-dialog {
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 24px rgba(0, 10, 26, 0.15);

      .el-dialog__header {
        padding: 16px 20px;
        border-bottom: 1px solid #e2e8f0;
        background: #f8fafc;
        margin: 0;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(to right, #1890ff, #36a9f7);
        }

        .el-dialog__title {
          font-size: 18px;
          font-weight: 600;
          color: #1a202c;
        }

        .el-dialog__headerbtn {
          top: 16px;
          right: 20px;

          .el-dialog__close {
            color: #64748b;
            transition: all 0.3s ease;

            &:hover {
              color: #1890ff;
            }
          }
        }
      }

      .el-dialog__body {
        padding: 24px;
      }

      .el-dialog__footer {
        padding: 16px 20px;
        border-top: 1px solid #e2e8f0;
        background: #f8fafc;
      }
    }

    .brand-form {
      .form-item-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #718096;
        line-height: 1.5;
      }

      .el-form-item {
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        ::v-deep .el-form-item__label {
          font-weight: 500;
          color: #2c3e50;
        }
      }

      ::v-deep .el-input__inner {
        border-radius: 8px;
        transition: all 0.3s ease;
        height: 40px;
        border-color: #e2e8f0;

        &:hover {
          border-color: #1890ff;
        }

        &:focus {
          border-color: #1890ff;
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
        }
      }

      ::v-deep .el-input__prefix {
        left: 12px;
        color: #a0aec0;
      }

      ::v-deep .el-input--prefix .el-input__inner {
        padding-left: 36px;
      }

      .upload-container {
        .brand-logo-preview {
          width: 120px;
          height: 120px;
          object-fit: contain;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .upload-placeholder {
          width: 120px;
          height: 120px;
          border: 1px dashed #e2e8f0;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #a0aec0;
          transition: all 0.3s ease;

          i {
            font-size: 24px;
            margin-bottom: 8px;
          }

          .upload-text {
            text-align: center;

            span {
              font-size: 14px;
            }

            .upload-hint {
              margin-top: 4px;
              font-size: 12px;
              color: #a0aec0;
            }
          }

          &:hover {
            border-color: #1890ff;
            color: #1890ff;
            background-color: #f0f9ff;
          }
        }

        .upload-tip {
          margin-top: 8px;
          display: flex;
          align-items: center;
          color: #718096;
          font-size: 12px;
          line-height: 1.6;

          i {
            margin-right: 4px;
            color: #1890ff;
            font-size: 14px;
          }
        }

        ::v-deep .el-upload {
          cursor: pointer;

          &:hover {
            .upload-placeholder {
              border-color: #1890ff;
              color: #1890ff;
              background-color: #f0f9ff;
            }
          }
        }
      }

      .brand-type-group {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .brand-type-radio {
          margin-right: 0;
          width: 100%;
          padding: 0;
          position: relative;

          ::v-deep .el-radio__input {
            position: absolute;
            right: 16px;
            top: 16px;
            margin: 0;
            z-index: 2;
          }

          ::v-deep .el-radio__label {
            padding: 0;
            margin: 0;
            width: 100%;
          }

          .radio-content {
            display: flex;
            padding: 16px;
            border: 2px solid #e2e8f0;
            border-radius: 12px;
            transition: all 0.3s ease;
            width: 100%;
            box-shadow: 0 2px 8px rgba(0, 10, 26, 0.05);
            cursor: pointer;

            .radio-icon {
              width: 50px;
              height: 50px;
              border-radius: 12px;
              background: #f1f5f9;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 16px;
              flex-shrink: 0;
              transition: all 0.3s ease;

              i {
                font-size: 24px;
                color: #64748b;
                transition: all 0.3s ease;
              }
            }

            .radio-details {
              flex: 1;
              padding-top: 4px;

              .radio-label {
                font-weight: 600;
                color: #1a202c;
                font-size: 16px;
                margin-bottom: 6px;
              }

              .radio-desc {
                font-size: 13px;
                color: #64748b;
                line-height: 1.4;
              }
            }
          }

          &:hover {
            .radio-content {
              border-color: #1890ff;
              background-color: #f0f9ff;
              transform: translateY(-3px);
              box-shadow: 0 6px 16px rgba(24, 144, 255, 0.15);

              .radio-icon {
                background: #e6f7ff;
                transform: scale(1.05);

                i {
                  color: #1890ff;
                }
              }
            }
          }

          ::v-deep &.is-checked {
            .el-radio__input {
              .el-radio__inner {
                background-color: #1890ff;
                border-color: #1890ff;
                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);

                &::after {
                  transform: translate(-50%, -50%) scale(1);
                }
              }
            }

            .radio-content {
              border-color: #1890ff;
              background-color: #f0f9ff;
              box-shadow: 0 6px 16px rgba(24, 144, 255, 0.15);

              .radio-icon {
                background: #1890ff;
                transform: scale(1.05);

                i {
                  color: #fff;
                }
              }

              .radio-label {
                color: #1890ff;
              }
            }
          }
        }
      }

      .form-footer-tip {
        margin-top: 16px;
        padding: 10px 12px;
        background: #f9fafb;
        border-radius: 6px;
        border-left: 3px solid #f59e0b;
        display: flex;
        align-items: center;

        i {
          font-size: 16px;
          color: #f59e0b;
          margin-right: 8px;
        }

        span {
          font-size: 13px;
          color: #4a5568;
        }
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;

      .el-button {
        padding: 0 20px;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.3s ease;
        height: 40px;

        i {
          margin-right: 4px;
        }

        &:hover {
          transform: translateY(-1px);
        }

        &[plain] {
          border-color: #e2e8f0;
          color: #4a5568;

          &:hover {
            border-color: #1890ff;
            color: #1890ff;
          }
        }

        &[type="primary"] {
          background-color: #1890ff;
          border-color: #1890ff;

          &:hover {
            background-color: #40a9ff;
            border-color: #40a9ff;
          }
        }
      }
    }
  }
}
</style>
